export const updateUrlOnLinkClick = (page: number, pageParamName: string, newHash: string) => {
  const url = new URL(window.location.href);
  if (page === 1) {
    url.searchParams.delete(pageParamName);
  } else {
    url.searchParams.set(pageParamName, String(page));
  }
  url.hash = newHash;
  history.pushState(null, '', url.toString());
};
